import {useHeaderPageData} from '../page-data/loaders/use-header-page-data'

export function usePullRequestState() {
  const {
    data: {
      pullRequest: {state},
    },
  } = useHeaderPageData()

  return state
}
